import { render, staticRenderFns } from "./PowerPointIcon.vue?vue&type=template&id=1e707228&scoped=true&"
import script from "./PowerPointIcon.vue?vue&type=script&lang=ts&"
export * from "./PowerPointIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PowerPointIcon.vue?vue&type=style&index=0&id=1e707228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e707228",
  null
  
)

export default component.exports